require('angular');
require('./angular-columnify');
module.exports = 'hj.columnify';
